import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import { IModalPictureInfoState, initialModalPictureInfoState } from './ModalPictureInfo.model'

@Component
export default class ModalPictureInfoComponent extends Vue {
    @Ref('modalPictureInfor') readonly modalPictureInfo!: any
    @Prop() imageInfo!: Map<string, string>

    state: IModalPictureInfoState
    constructor() {
        super()
        this.state = initialModalPictureInfoState()
    }

    public show(...imageInfo: any): void {
        this.state.info = imageInfo
        this.modalPictureInfo.show()
    }
}
